<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor mgb-15"
      @click="$router.push('/shebei/homeShebeilist')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>

    <!-- 设备详情 -->
    <div class="pd-5 bg-white">
      <!-- <el-button type="primary" class="mgb-15" @click="openLog"
          >设备日志</el-button
        > -->
      <el-descriptions border column="5">
        <el-descriptions-item label="设备类型">{{
          detailForm.dictName
        }}</el-descriptions-item>
        <el-descriptions-item label="设备型号">{{
          detailForm.equipmentVersion
        }}</el-descriptions-item>
        <el-descriptions-item label="设备编号">{{
          detailForm.equipmentNum
        }}</el-descriptions-item>
        <el-descriptions-item label="设备批次号">{{
          detailForm.futureBatchId
        }}</el-descriptions-item>
        <el-descriptions-item label="设备来源">{{
          detailForm.equipmentSource
        }}</el-descriptions-item>
        <el-descriptions-item label="出厂时间">{{
          detailForm.createTime
        }}</el-descriptions-item>
        <el-descriptions-item label="设备归属">{{
          detailForm.companyName
        }}</el-descriptions-item>
        <el-descriptions-item label="绑定状态">{{
          detailForm.bindTime ? "已绑定" : "未绑定"
        }}</el-descriptions-item>
        <el-descriptions-item label="制水状态">- -</el-descriptions-item>
        <el-descriptions-item label="联网状态">{{
          detailForm.status === 0 ? "离线" : "在线"
        }}</el-descriptions-item>
        <el-descriptions-item label="设备状态">{{
          Number(detailForm.error) === 0 ? "正常" : "异常"
        }}</el-descriptions-item>
        <el-descriptions-item label="启用状态">{{
          detailForm.usingStatus === 0
            ? "禁用"
            : detailForm.usingStatus === 1
            ? "启用"
            : "- -"
        }}</el-descriptions-item>
        <el-descriptions-item label="开关机状态">{{
          detailForm.onoff === 0
            ? "已关机"
            : detailForm.onoff === 1
            ? "已开机"
            : "- -"
        }}</el-descriptions-item>
        <el-descriptions-item label="最后连接时间">- -</el-descriptions-item>
        <el-descriptions-item label="设备制水总量">- -</el-descriptions-item>
        <el-descriptions-item label="设备工作时间">- -</el-descriptions-item>
        <el-descriptions-item label="使用天数">- -</el-descriptions-item>

        <el-descriptions-item label="设备地址">{{
          detailForm.equipmentPlace
        }}</el-descriptions-item>
        <el-descriptions-item label="现场照片">
          <img
            class="imgheat"
            :src="v"
            alt=""
            v-for="(v, i) in detailForm.customerFace"
            :key="i"
          />
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <!-- 设备日志弹框 -->
    <el-dialog
      title="设备日志"
      :visible.sync="logVisible"
      width="30%"
      :close-on-click-modal="false"
      top="30vh"
      center
    >
      <el-table border :data="logData" stripe style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="80"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="date" label="时间"> </el-table-column>
        <el-table-column prop="name" label="设备行为"> </el-table-column>
        <el-table-column prop="address" label="操作结果"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logVisible = false">已知晓</el-button>
      </span>
    </el-dialog>

    <!-- 用户信息 -->
    <div class="flex aic mgt-15 mgb-15">
      <div class="f18 fw-600 mgr-30">用户信息</div>
      <el-button type="primary" @click="jiebangBtn" v-if="detailForm.bindTime"
        >设备解绑</el-button
      >
      <!-- <el-button type="primary" @click="bangdingBtn" v-else>设备绑定</el-button> -->
      <!-- <el-button type="primary" @click="openJilu">操作记录</el-button> -->
    </div>
    <div class="colorf00" v-if="!detailForm.bindTime">该设备未绑定用户</div>

    <div class="pd-5 bg-white" v-if="detailForm.bindTime">
      <el-descriptions border column="5">
        <el-descriptions-item label="用户电话">{{
          detailForm.customerPhone
        }}</el-descriptions-item>
        <el-descriptions-item label="绑定时间">{{
          detailForm.bindTime
        }}</el-descriptions-item>
        <el-descriptions-item label="操作人">{{
          detailForm.addBindUserName
        }}</el-descriptions-item>
        <!-- <el-descriptions-item label="用水总量">- -</el-descriptions-item>
          <el-descriptions-item label="绑定备注">- -</el-descriptions-item> -->
      </el-descriptions>
    </div>

    <!-- 设备解绑弹框 -->
    <el-dialog
      title="设备解绑"
      :visible.sync="jiebangVisible"
      width="30%"
      :close-on-click-modal="false"
      top="30vh"
      center
    >
      <el-form
        ref="jiebangForm"
        :rules="jiebangRules"
        :model="jiebangForm"
        label-width="80px"
      >
        <el-form-item label="解绑备注" prop="desc">
          <el-input
            placeholder="请填写5字以上解绑备注"
            type="textarea"
            v-model="jiebangForm.desc"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div>设备解绑后用户将无法使用设备，请确定已进行设备拆机回收。</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="jiebangVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleJie('jiebangForm')"
          >提交审核</el-button
        >
      </span>
    </el-dialog>

    <!-- 设备绑定弹框 -->
    <el-dialog
      title="设备解绑"
      :visible.sync="bangdingVisible"
      width="30%"
      :close-on-click-modal="false"
      top="30vh"
      center
    >
      <el-form
        ref="bangdingForm"
        :rules="bangdingRules"
        :model="bangdingForm"
        label-width="80px"
      >
        <el-form-item label="绑定用户" prop="phone">
          <el-input
            placeholder="请输入用户手机号"
            v-model="bangdingForm.phone"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="colorf00">
        温馨提示：绑定手机号需与用户授权登录【纯璟泉】小程序手机号一致。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="bangdingVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleBang('bangdingForm')"
          >绑 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 绑定记录弹框 -->
    <el-dialog
      title="操作记录"
      :visible.sync="jiluVisible"
      width="50%"
      :close-on-click-modal="false"
      top="30vh"
      center
    >
      <el-table height="400" border :data="jiluData" stripe style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod2"
          label="序号"
          width="80"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="status" label="类型">
          <template slot-scope="scope">
            <span v-text="scope.row.status === 1 ? '绑定' : '解绑'"></span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间"> </el-table-column>
        <el-table-column prop="userName" label="绑定用户"> </el-table-column>
        <el-table-column prop="addUserName" label="操作人"> </el-table-column>

        <el-table-column prop="address" label="使用天数">
          <template slot-scope="scope">
            <span>- -</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="用水总量">
          <template slot-scope="scope">
            <span>- -</span>
          </template>
        </el-table-column>
        <el-table-column prop="equipmentPlace" label="设备位置">
        </el-table-column>
        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            <span v-text="scope.row.remark ? scope.row.remark : '- -'"></span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jiluVisible = false">已知晓</el-button>
      </span>
    </el-dialog>

    <!-- 滤芯信息 -->
    <div class="flex aic mgt-15 mgb-15">
      <div class="f18 fw-600 mgr-30">滤芯信息</div>
      <el-button type="primary" @click="addFilterVis">添加滤芯</el-button>
    </div>

    <el-table :data="filterTable" border stripe style="width: 100%">
      <el-table-column prop="filterElementName" label="滤芯名称">
      </el-table-column>
      <el-table-column prop="changeTime" label="更换周期（天）">
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.status === 0
                ? '停用'
                : scope.row.status === 1
                ? '启用'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="baifen" label="未使用百分比"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="endTime" label="到期时间"></el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleChong(scope.row)">
            重置
          </el-button>
          <!-- <el-button
              v-if="scope.row.status === 0"
              type="text"
              size="small"
              @click="handleStart(scope.row)"
            >
              启用
            </el-button>
            <el-button
              v-if="scope.row.status === 1"
              type="text"
              size="small"
              @click="handleStop(scope.row)"
            >
              停用
            </el-button> -->
          <el-button type="text" size="small" @click="filterDel(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增滤芯弹框 -->
    <el-dialog
      title="新增"
      :visible.sync="dialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <el-form
        :rules="addFilterFormRules"
        ref="addFilterForm"
        :model="addFilterForm"
        label-width="80px"
      >
        <el-form-item label="滤芯" prop="name">
          <el-select
            multiple
            filterable
            v-model="addFilterForm.name"
            placeholder="请选择需要添加的滤芯"
          >
            <el-option
              v-for="v in filterArr"
              :key="v.id"
              :label="v.filterElementName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="addFilter('addFilterForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 登录密码确认弹框 -->
    <el-dialog
      :title="'密码确认'"
      :visible.sync="pwdSureVisible"
      width="20%"
      top="50vh"
      center
      :close-on-click-modal="false"
    >
      <el-form ref="pwdForm" :model="pwdForm" label-width="80px" inline>
        <el-form-item
          label="登录密码"
          prop="password"
          :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
        >
          <div class="codeDiv">
            <el-input
              show-password
              v-model="pwdForm.password"
              placeholder="请输入登录密码"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pwdSureVisible = false">取 消</el-button>
        <el-button type="primary" @click="pwdSure('pwdForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    const rulesPhone = (rule, value, callback) => {
      var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!reg.test(value)) {
        callback(new Error("手机号不正确，请重新输入"));
      } else {
        callback();
      }
    };
    return {
      filterTable: [],
      addFilterForm: { name: [] },
      filterArr: [],
      addFilterFormRules: {
        name: [{ required: true, message: "请选择滤芯", trigger: "blur" }],
      },
      dialogVisible: false,
      pwdSureVisible: false,
      filterId: null,
      pwdForm: {
        password: "",
      },
      logVisible: false, //设备日志弹框
      logData: [],
      jiluVisible: false, //设备日志弹框
      jiluData: [],
      jiebangVisible: false,
      jiebangForm: { desc: "" },
      jiebangRules: {
        desc: [
          { required: true, message: "请输入解绑备注", trigger: "blur" },
          {
            min: 5,
            max: 50,
            message: "长度在 5 到 50 个字符",
            trigger: "blur",
          },
        ],
      },
      bangdingVisible: false,
      bangdingForm: { phone: "" },
      bangdingRules: {
        phone: [{ required: true, validator: rulesPhone, trigger: "blur" }],
      },
      dataInfo: null,
      detailForm: {},
    };
  },
  created() {
    console.log(this.$route.query, "传参的");
    this.dataInfo = this.$route.query.data;
    this.getInfo();
    this.getFilter(); //滤芯列表
  },
  methods: {
    // 设备绑定
    handleBang(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认绑定吗?", "info")
            .then(() => {
              this.$api.shebei
                .shebeiBangUser({
                  equipmentId: this.dataInfo.id,
                  phone: this.bangdingForm.phone,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("绑定成功", "success");
                    this.bangdingVisible = false;
                    this.getInfo();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    // 设备解绑
    handleJie(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认解绑吗?", "info")
            .then(() => {
              this.$api.shebei
                .shebeiJieUser({
                  equipmentId: this.dataInfo.id,
                  id: this.detailForm.userEquipmentId,
                  phone: this.detailForm.customerPhone,
                  remark: this.jiebangForm.desc,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("已提交审核", "success");
                    this.jiebangVisible = false;
                    this.getInfo();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    // 设备详情
    getInfo() {
      this.$api.shebei.homeShebeiInfo({ id: this.dataInfo.id }).then((res) => {
        console.log(res, "设备详情");
        if (res.code === 200) {
          this.detailForm = res.data;
        }
      });
    },

    // 解绑按钮
    jiebangBtn() {
      this.jiebangForm = { desc: "" };
      this.jiebangVisible = true;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.jiebangForm.clearValidate();
      });
    },

    // 绑定按钮
    bangdingBtn() {
      this.bangdingForm = { phone: "" };
      this.bangdingVisible = true;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.bangdingForm.clearValidate();
      });
    },
    // 打开操作日志
    openLog() {
      this.logVisible = true;
    },
    // 打开绑定记录
    openJilu() {
      this.$api.shebei
        .homeJilu({ equipmentId: this.dataInfo.id })
        .then((res) => {
          if (res.code === 200) {
            this.jiluData = res.data;
            this.jiluVisible = true;
          }
        });
    },
    // 滤芯
    getFilterPull() {
      this.$api.shebei.filterList().then((res) => {
        if (res.code === 200) {
          this.filterArr = res.data;
        }
      });
    },
    addFilterVis() {
      this.dialogVisible = true;
      this.addFilterForm = { name: [] };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addFilterForm.clearValidate();
      });
      this.getFilterPull();
    },
    // 滤芯列表
    getFilter() {
      this.$api.shebei.filter({ id: this.dataInfo.id }).then((res) => {
        if (res.code === 200) {
          this.filterTable = res.data;
          this.filterTable.forEach((v) => {
            v.baifen = this.jindu(v) + "%";
            v.endTime = this.addDaysToDate(v.createTime, v.changeTime);
          });
        }
      });
    },

    // 添加滤芯
    addFilter(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认保存吗", "info")
            .then(() => {
              this.$api.shebei
                .filteradd({
                  futureElementFiltersBeans: this.addFilterForm.name,
                  futureEquipmentId: this.dataInfo.id,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("保存成功", "success");
                    this.getFilter();
                    this.dialogVisible = false;
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    // 滤芯删除
    filterDel(row) {
      if (row.status === 1) {
        handleAlert("已启用的滤芯无法删除", "error");
        return;
      }
      handleConfirm("确认删除该滤芯吗?", "info")
        .then(() => {
          this.$api.shebei.filterDel({ id: row.id }).then((res) => {
            if (res.code === 200) {
              handleAlert("删除成功", "success");
              this.getFilter();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    addDaysToDate(startDate, days) {
      const startDateObj = new Date(startDate);
      const millisecondsToAdd = days * 24 * 60 * 60 * 1000;

      // 计算相加后的时间（以毫秒为单位）
      const resultTime = startDateObj.getTime() + millisecondsToAdd;

      // 创建新的Date对象来表示相加后的日期

      const resultDate = new Date(resultTime);

      // 格式化日期字符串（年-月-日 时:分:秒）
      const formattedResult = resultDate
        .toISOString()
        .replace("T", " ")
        .slice(0, 19);

      return formattedResult;
    },

    jindu(v) {
      // console.log(v, '进度');
      let startTime = new Date(v.createTime).getTime(); //开始时间
      let endTime = this.GetDateStr(v.changeTime).getTime(); //到期时间
      let currentTime = new Date().getTime(); //现在时间
      var totalTime = endTime - startTime;
      var elapsedTime = currentTime - startTime;
      var progress = (elapsedTime / totalTime) * 100;
      return parseFloat(100 - progress).toFixed(0);
    },

    GetDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount);
      return dd;
    },

    getDaysBetween(startDateStr, endDateStr) {
      if (startDateStr === this.formatDate(endDateStr)) {
        return 0;
      }
      var startDate = new Date(startDateStr);
      var endDate = new Date(endDateStr);
      var startTimestamp = startDate.getTime();
      var endTimestamp = endDate.getTime();
      var timeDiff = Math.abs(endTimestamp - startTimestamp);
      var dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return dayDiff;
    },

    formatDate(dateStr) {
      var date = new Date(dateStr);
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var hours = ("0" + date.getHours()).slice(-2);
      var minutes = ("0" + date.getMinutes()).slice(-2);
      var seconds = ("0" + date.getSeconds()).slice(-2);

      var formattedDate =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;

      return formattedDate;
    },

    // 重置按钮
    handleChong(row) {
      this.filterId = row.id;
      this.pwdSureVisible = true;
      this.pwdForm = { password: "" };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.pwdForm.clearValidate();
      });
    },

    // 密码确认后重置
    pwdSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          this.$api.shebei
            .pwdNotarize({ password: this.pwdForm.password })
            .then((res) => {
              if (res.data === "密码错误!") {
                handleAlert("密码错误，请重新输入", "error");
                this.pwdForm = { name: "" };
              } else {
                this.pwdSureVisible = false;
                handleConfirm("确认重置该滤芯吗?", "info")
                  .then(() => {
                    // 重置接口===========
                    this.$api.shebei
                      .filterYuan({ id: this.filterId })
                      .then((res) => {
                        if (res.code === 200) {
                          handleAlert("滤芯已重置", "success");
                          this.getFilter();
                        }
                      });
                  })
                  .catch(() => {
                    return;
                  });
              }
            });
        } else {
          return false;
        }
      });
    },

    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod2(index) {
      return index + 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.imgheat {
  width: 50px;
  height: 50px;
  margin: 0 5px;
}
</style>
